import { Link } from 'react-router-dom';
import { appUrl } from '../lib/site';
import { Logo } from './Logo';

type SiteHeaderProps = {
  theme?: 'dark' | 'light';
};

export const SiteHeader = ({ theme = 'light' }: SiteHeaderProps) => {
  const dark = theme === 'dark';
  const textClass = dark ? 'text-white/72 hover:text-white' : 'text-muted hover:text-foreground';
  const buttonClass = dark
    ? 'border-white/18 text-white hover:border-white/40'
    : 'border-border text-foreground hover:border-primary/50';

  return (
    <header className="mx-auto flex w-full max-w-7xl items-center justify-between gap-5 px-5 py-6">
      <Link to="/" aria-label="ADarveo home">
        <Logo variant={dark ? 'transparent' : 'light'} className="h-11 w-auto" />
      </Link>
      <div className="flex items-center gap-3 text-sm">
        <nav className="hidden items-center gap-5 md:flex" aria-label="Primary navigation">
          <a className={`transition ${textClass}`} href="/#how-it-works">
            How it works
          </a>
          <Link className={`transition ${textClass}`} to="/pricing">
            Pricing
          </Link>
          <Link className={`transition ${textClass}`} to="/contact">
            Support
          </Link>
        </nav>
        <a className={`rounded-md border px-4 py-2 font-medium transition ${buttonClass}`} href={appUrl}>
          Dashboard
        </a>
      </div>
    </header>
  );
};

